<template src="./App.html">
</template>


<script>
import axios from "axios";

import errorMessage from "./components/global/ErrorMessage.vue";
import mainHeader from "./components/global/Header.vue";
import mainFooter from "./components/global/Footer.vue";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'hamburgers/dist/hamburgers.min.css';

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  name: "app",
  components: {
    errorMessage,
    mainHeader,
    mainFooter
  },

  data() {
    return {
      isLoading: false,
      sessionExpiredError: null,
      responseError: null,
      notAUser: false,
    }
  },
  created() {
    axios.interceptors.request.use((config) => {
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      if (this.sessionExpiredError) this.sessionExpiredError = null;
      if (response.data.errors) {
        // this case is for a 200 response that nonetheless has an error node
        this.responseError = { response };
      }
      return response;
    }, (error) => {
      this.responseError = error;
      if (error.response.data && error.response.data.type === "BenefitPointSessionExpired") {
        this.sessionExpiredError = error;
      }
      return Promise.reject(error);
    });
  }
};
</script>


<style lang="scss">
@import "./assets/scss/main.scss";
</style>
